/**
 * Axios interceptor for handling token expiry and authentication errors
 */
import { auth } from './auth';

export const setupAxiosInterceptors = (router) => {
  // Response interceptor to handle 401 or token expiry errors
  return {
    interceptors: {
      response: {
        onFulfilled: (response) => response,
        onRejected: (error) => {
          // Check for 401 Unauthorized or token expiry
          if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // Token expired or unauthorized
            console.log('Token expired or unauthorized:', error.response.status);
            
            // Clear authentication data
            auth.logout();
            
            // Redirect to login
            if (router) {
              router.push({
                name: 'Login',
                query: { redirect: router.currentRoute.fullPath }
              });
            }
          }
          // Check if response data contains token expiry error code
          else if (error.response && error.response.data) {
            const code = error.response.data.code;
            const desc = error.response.data.desc;
            
            // Common token expiry error codes
            if (code === -1 || desc && desc.includes('token') || desc && desc.includes('expired')) {
              console.log('Token expired based on response:', error.response.data);
              
              // Clear authentication data
              auth.logout();
              
              // Redirect to login
              if (router) {
                router.push({
                  name: 'Login',
                  query: { redirect: router.currentRoute.fullPath }
                });
              }
            }
          }
          
          return Promise.reject(error);
        }
      }
    }
  };
};

export default setupAxiosInterceptors;
